<template>
  <div>
    <no-content
      :show="uploadHistoryData.length === 0"
      text="No Data Available"
    />
    <div v-if="uploadHistoryData.length > 0">
      <div class="mb-3">
        <filter-component
          :items="uploadHistoryData"
          @filtered="handleFiltered"
        />
      </div>
      <div
        class="table-wrapper"
      >
        <b-table
          id="upload-history-table"
          ref="table"
          :per-page="perPage"
          :current-page="page.currentPage"
          :items="currentData"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          bordered
          responsive
          sticky-header="60vh"
        >
          <template #cell(UploadStatusName)="row">
            <b-badge
              data-toggle="tooltip"
              data-placement="bottom"
              :title="getStatusValue(row)"
              :variant="getStatusBadgeVariant(row)"
              class="td-actual-content"
            >
              {{ getStatusValue(row) }}
            </b-badge>
          </template>

          <template #cell()="data">
            <span
              v-if="!isDateField(data)"
              :class="[isNumberField(data) ? 'font-weight-bold' : 'font-weight-normal', 'font-12']"
            >
              {{ data.value }}
            </span>

            <span
              v-else
              :class="[isNumberField(data) ? 'font-weight-bold' : 'font-weight-normal', 'font-12']"
              :title="data.value"
            >
              {{ formatDate(data.value) }}
            </span>
          </template>
          
          <template #cell(actions)="row">
            <b-button
              id="toggle-details-btn"
              variant="outline-secondary"
              size="sm"
              :class="{ active: selectedRow === row.item.UploadId }"
              @click="toggleDetails(row)"
            >
              {{ selectedRow === row.item.UploadId ? 'Hide' : 'Show' }} Details
            </b-button>
          </template>

          <template #row-details="row">
            <UploadDetailsDrawer
              v-if="selectedRow === row.item.UploadId"
              :item="row.item"
              :columns="fields.length"
            />
          </template>
        </b-table>

        <no-content
          :show="filteredData && filteredData.length === 0"
          text="There are no records matching your request"
        />
      
        <div class="d-flex justify-content-between main-header-wrapper">
          <div class="d-flex align-items-center">
            <pagination-summary
              v-if=" currentData.length > 0"
              :total="currentData.length"
              :page="page.currentPage"
              :per-page="perPage"
            />
            <b-form-select
              v-model="perPage"
              class="per-page-select ml-2"
              :options="perPageOptions"
              @change="onPerPageChange"
            />
          </div>
          <b-pagination
            v-if=" currentData.length > perPage"
            v-model="page.currentPage"
            class="mb-0"
            :total-rows="currentData.length"
            :per-page="perPage"
            @input="onCurrentPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import PaginationSummary from '@/core/components/complex-table/components/PaginationSummary.vue';
import NoContent from '@/core/components/NoContent.vue';
import FilterComponent from './FilterComponent.vue';
import UploadDetailsDrawer from './UploadDetailsDrawer.vue';
import moment from 'moment/moment';

const {
  mapState: uploadHistoryMapState, 
  mapActions: uploadHistoryMapActions,
} = createNamespacedHelpers('dataManagement');

export default {
  name: 'UploadHistoryTable',
  props: {
    tableIds: Array,
  },
  components: {
    PaginationSummary,
    NoContent,
    FilterComponent,
    UploadDetailsDrawer,
  },
  data() {
    return {
      sortBy: 'StartTime',
      sortDesc: true,
      sortDirection: 'desc',
      perPage: 10,
      perPageOptions: [10, 20, 30, 50, 100],
      fields: [
        { key: 'TableName', label: 'Table Name', thClass: 'table-name' },
        { key: 'StartTime', label: 'Start Time', thClass: 'time-cols' },
        { key: 'EndTime', label: 'End Time', thClass: 'time-cols'  },
        { key: 'UploadStatusName', label: 'Status' },
        { key: 'TotalRecords', label: '# Total Records' },
        { key: 'RecordsRejected', label: '# Rejected' },
        { key: 'RecordsUploaded', label: '# Uploaded' },
        { key: 'RecordsIgnored', label: '# Ignored' },
        { key: 'RecordsInserted', label: '# Inserted' },
        { key: 'RecordsDeleted', label: '# Deleted' },
        { key: 'RecordsUpdated', label: '# Updated' },
        { key: 'UploadedByUsername', label: 'Uploaded By' },
        { key: 'actions', label: '', thClass: 'actions-col' },
      ],
      filteredData: null,
      selectedRow: null,
    };
  },
  computed: {
    ...uploadHistoryMapState({
      uploadHistoryData: state => state.uploadHistory.data,
      page: state => state.uploadHistory.page,
    }),
    currentData(){
      return this.filteredData || this.uploadHistoryData;
    },
  },
  methods: {
    ...uploadHistoryMapActions(['getUploadHistoryData']),
    capitalize(val) {
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
    onPerPageChange() {
      this.page.currentPage = 1;
      this.$emit(
        'on-pagination-change',
        {
          perPage: this.perPage,
          currentPage: this.page.currentPage,
        },
      );
    },
    getStatusValue(row) {
      console.log(row.item.UploadStatusName);
      return this.capitalize(row.item?.UploadStatusName);
    },
    getStatusBadgeVariant(row) {
      
      console.log(row.item.UploadStatusName);
      return row.item?.UploadStatusName === 'failed'
        ? 'danger'
        :'success';
    },
    onCurrentPageChange() {
      this.$emit(
        'on-pagination-change',
        {
          perPage: this.perPage,
          currentPage: this.page.currentPage,
        });
    },
    handleFiltered(data) {
      this.filteredData = data;
    },
    toggleDetails(row) {
      if (row.item.UploadId === this.selectedRow) {
        this.selectedRow = null;
        row.item._showDetails = false;
      } else {
        this.selectedRow = row.item.UploadId;
        this.currentData.forEach((item, index) => {
          if (index !== row.item.UploadId) {
            item._showDetails = false;
          }
        });
        row.item._showDetails = true;
      }
    },
    isNumberField({ item, field }) {
      const numberFields = ['TotalRecords', 'RecordsRejected', 'RecordsUploaded', 'RecordsIgnored', 'RecordsInserted', 'RecordsDeleted', 'RecordsUpdated'];
      return numberFields.includes(field.key) && item[field.key] !== 0;
    },
    isDateField({ item, field }) {
      const dateFields = ['StartTime', 'EndTime'];
      return dateFields.includes(field.key) && item[field.key] !== 0;
    },
    formatDate(dateStr) {
      return moment(dateStr).format('D MMM, \'YY, HH:mm');
    },
  },
  async mounted () {
    await this.getUploadHistoryData(this.tableIds);
    if (this.tableIds.length == 1) {
      this.fields = this.fields.filter(f => f.key !== 'TableName');
    }
  },
};
</script>

<style>
.table-wrapper {
  max-height: 90vh;
  overflow-y: auto;
}

.table thead th {
  vertical-align: top !important;
  position: sticky !important;
  white-space: nowrap;
  font-size: 14px;
}
.table td{
  
  white-space: nowrap;
}

.pagination-summary {
  white-space: nowrap;
}

.actions-col {
  width: 90px;
}

.time-cols {
  min-width: 80px;
}
.font-12{
  font-size:12px;
}
</style>